import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Functionality } from "@common/models/functionality";
import { environment } from "environments/environment";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class FunctionalityService {
    constructor(private _http: HttpClient) { }

    getAll() {
        return this._http.get<Functionality[]>(
            `${environment.commonApiUrl}/api/functionality`
        );
    }

    getById(id: number) {
        return this._http.get<Functionality>(`${environment.commonApiUrl}/api/functionality/${id}`);
    }

    addFunctionality(functionality) {
        return this._http.post<Functionality>(`${environment.commonApiUrl}/api/functionality`, functionality).pipe(
            map((response: any) => response.functionality as Functionality),
            catchError(e => {
                return throwError(e);
            })
        );
    }

    editFunctionality(functionality) {
        return this._http.put<Functionality>(`${environment.commonApiUrl}/api/functionality/${functionality.id}`, functionality).pipe(
            map((response: any) => response.functionality as Functionality),
            catchError(e => {
                return throwError(e);
            })
        );
    }

    changeStatus(id: number, statusId: number) {
        return this._http.put<Functionality>(`${environment.commonApiUrl}/api/functionality/${id}/${statusId}`, {}).pipe(
            map((response: any) => response.functionality as Functionality),
            catchError(e => {
                return throwError(e);
            })
        );
    }
}
